const pigColors = {
  yellow: 'yellow',
  red: 'red',
  blue: 'blue',
};

// const pigImage = [ pigRed, pigBlue, pigYellow ];
const pigClassNames = ['blue', 'red', 'yellow'];

export { pigColors, pigClassNames };
